import { TFunction } from 'i18next';

const formatPackageCounts = (t: TFunction, parcels: number, envelopes: number): string => {
  const parts = [
    parcels > 0 ? t('awb.parcel_count', { count: parcels }) : null,
    envelopes > 0 ? t('awb.envelope_count', { count: envelopes }) : null,
  ].filter((part): part is string => part !== null);
  return parts.length > 0 ? parts.join(', ') : t('awb.parcel_count', { count: 0 });
};

export default formatPackageCounts;
